import { render, staticRenderFns } from "./DataStore.vue?vue&type=template&id=9dc6e764&"
import script from "./DataStore.vue?vue&type=script&lang=js&"
export * from "./DataStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports